import React, {useEffect, useState} from 'react';
import SecondryButton from '../Component/SecondryButton';
import Modal from '../Component/UI/modals/Modal';
import CreateAccount from './CreateUser';
import CreateUser from './CreateUser';

const CreateUserButton = ({load_users}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <SecondryButton
        showBtn={true}
        btnTitle={'Create User'}
        btnAction={() => setIsOpen(true)}
      />

      {/*  modal for configs */}
      {isOpen && (
        <Modal onCloseModal={() => setIsOpen(false)}>
          <div className=" max-w-[700px]  absolute right-0 top-0 w-full h-full grid place-items-start bg-white  backdrop-blur-sm z-50 px-4 py-2">
            <CreateUser
              closeModal={() => {
                load_users();
                setIsOpen(false);
              }}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default CreateUserButton;
